





























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { SelectBGMState } from "@/common/interface";
import { majorNoticeText } from '@/common/constants/index';

@Component
export default class MusicListModal extends Vue {
  @Prop(Boolean) show!: boolean;
  @Getter("xcxFlag") xcxFlag!: boolean;
  @Getter("orgId") orgId!: string;
  @Getter("mainTextColor") mainTextColor!: string;
  @Getter("titleSection") titleSection!: string;
  @Getter("bgmList") bgmList!: Array<string>;
  @Getter("customizeBgmList") customizeBgmList!: Array<string>;
  @Getter("musicTagBgColor") musicTagBgColor!: string;
  @Getter("musicTagTextColor") musicTagTextColor!: string;
  @Getter("selectedBGM") selectedBGM!: SelectBGMState;
  @Getter("modalSection") modalSection!: object;
  @Getter("xcxType") xcxType!: string;
  @Action("getBGMList")  getBGMList!: Function;
  @Action("getCustomizeBGMList") getCustomizeBGMList!: Function;
  @Action("changeSelectBGM") changeSelectBGM!: Function;

  ownSelectedBgm = {};
  nowIndex: any = 0;
  majorNoticeText: string = majorNoticeText;
  tabsParam:Array<string> = ["音乐库","自定义音乐"];

  @Watch('orgId')
  onChangeTab(val: string) {
    if (val) {
      this.tabsParam = ['音乐库'];
    }
  }

  @Watch("selectedBGM", { deep: true })
  onSelectedBgmChange(val: SelectBGMState, oldVal: SelectBGMState) {
    this.ownSelectedBgm = val;
  }

  updated() {
    if (this.bgmList.length === 0) {
      this.getBGMList();
    }
  }

  toggleTabs(index:any): void{
    this.nowIndex = index;
    if((index===1) && !this.xcxFlag){
      this.getCustomizeBGMList();
    }
  }

  handleHideModal(): void {
    this.$emit("hide");
  }

  // 列表中选择某个音乐
  handleSelectMusic(item: any): void {
    this.ownSelectedBgm = item;
    const audio = document.getElementsByClassName("selected-bgm")[0];
    document.addEventListener(
      "WeixinJSBridgeReady",
      () => {
        (audio as HTMLAudioElement).play();
      },
      false
    );
  }

  handleOk() {
    const payload = {
      selectedBGM: this.ownSelectedBgm
    };
    this.changeSelectBGM(payload);
    this.$emit("hide");
  }
}
